import React, { useMemo } from 'react';
import { Heart, Star, MapPin } from 'lucide-react';
import { Property } from "../types";
import { useNavigate, createSearchParams } from 'react-router-dom';

interface PropertyCardProps {
    p: Property;
    checkIn?: string;
    checkOut?: string;
    guests?: number;
    // Nuova prop per la distanza
    distanceLabel?: string | null;
}

const PropertyCard = ({ p, checkIn, checkOut, guests, distanceLabel }: PropertyCardProps) => {
    const navigate = useNavigate();
    console.log(p)
    const pricing = useMemo(() => {
        if (p.totalPrice !== undefined && p.totalPrice !== null) {
            let nightsCount = p.nights;
            if (!nightsCount && checkIn && checkOut) {
                const start = new Date(checkIn);
                const end = new Date(checkOut);
                nightsCount = Math.ceil(Math.abs(end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24));
            }
            return {
                label: `total for ${nightsCount || 'stay'} nights`,
                price: p.totalPrice,
                isTotal: true,
                isExact: true
            };
        }
        const basePrice = p.price || 0;
        if (checkIn && checkOut) {
            const start = new Date(checkIn);
            const end = new Date(checkOut);
            const diffDays = Math.ceil(Math.abs(end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24));
            if (diffDays > 0) {
                return {
                    label: `total for ${diffDays} nights`,
                    price: basePrice * diffDays,
                    isTotal: true,
                    isExact: false
                };
            }
        }
        return { label: "night", price: basePrice, isTotal: false, isExact: false };
    }, [checkIn, checkOut, p.price, p.totalPrice, p.nights]);

    const handleClick = () => {
        const params: any = {};
        if (checkIn) params.checkIn = checkIn;
        if (checkOut) params.checkOut = checkOut;
        if (guests) params.guests = guests.toString();

        navigate({
            pathname: `/details/${p.id}`,
            search: createSearchParams(params).toString()
        });
    };

    return (
        <div onClick={handleClick} className="group cursor-pointer flex flex-col gap-3 animate-fade-in relative">
            <div className="relative aspect-[20/19] overflow-hidden rounded-xl bg-gray-200">
                <img src={p.image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 ease-out" />

                {/* TAG ESISTENTE (Sinistra) */}
                {p.tag && <div className="absolute top-3 left-3 bg-white/90 backdrop-blur-md px-3 py-1 rounded-full text-xs font-bold shadow-sm text-brand z-10">{p.tag}</div>}

                {/* NUOVO BADGE DISTANZA (Destra) */}
                {distanceLabel && (
                    <div className="absolute top-3 right-3 bg-black/70 backdrop-blur-md px-2.5 py-1 rounded-full text-[10px] font-bold shadow-sm text-white flex items-center gap-1 z-10">
                        <MapPin className="w-3 h-3 text-white" />
                        {distanceLabel}
                    </div>
                )}
            </div>

            <div className="flex justify-between items-start">
                <div>
                    <h3 className="font-bold text-primary leading-tight text-base">{p.location}</h3>
                    <p className="text-gray-500 text-sm mt-1">{p.type}</p>
                    <p className="text-gray-500 text-sm">{p.guests} Guests · {p.beds} Beds</p>

                    <div className="mt-2 flex items-baseline gap-1 flex-wrap">
                        <span className={`font-bold text-primary text-base ${pricing.isTotal ? 'underline decoration-brand decoration-2 underline-offset-2' : ''}`}>
                            $ {pricing.price?.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                        </span>
                        <span className="text-gray-900 text-sm font-medium">
                           {pricing.isTotal ? '' : '/'} {pricing.label}
                        </span>
                        {pricing.isExact && (
                            <span className="text-[10px] text-gray-400 font-bold uppercase tracking-wider ml-1 self-center">
                                incl. fees
                            </span>
                        )}
                    </div>
                </div>
                {(p.reviewsCount && p.reviewsCount > 0) ? (
                    <div className="flex items-center gap-1 text-sm font-medium">
                        <Star className="w-3.5 h-3.5 fill-brand stroke-brand" />
                        <span>{p.rating}</span>
                    </div>
                ) : null}
            </div>
        </div>
    );
};

export default PropertyCard;